import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import isBefore from 'date-fns/isBefore'

import { getHeader } from 'store/header/selectors'
import { getHeaderMenus } from 'store/menus/selectors'
import { getLoginButtonStrings } from 'store/strings/selectors'
import { getUserFirstName } from 'store/user/selectors'
import { formatDailyDate, formatDate } from 'ui-component-library/utils/helpers'
import Login from 'containers/Login'
import SearchBarPopup from 'ui-component-library/components/GoogleCustomSearch/SearchBarPopup'
import DatePicker from 'ui-component-library/components/00-Primitives/DatePicker'
import Header from 'ui-component-library/components/Header'

const GOOGLE_SEARCH_API_KEY = process.env.GOOGLE_SEARCH_API_KEY
const WODS_URL = process.env.WODS_URL

function HeaderContainer() {
  const history = useHistory()
  const location = useLocation()
  const shouldShowSearch = location.pathname !== '/search'

  const { datePicker, search, ...header } = useSelector(getHeader)
  const headerMenus = useSelector(getHeaderMenus)
  const userFirstName = useSelector(getUserFirstName)
  const { welcomeButtonText } = useSelector(getLoginButtonStrings)

  function handleDayClick(day: Date) {
    const isLegacy = isBefore(day, new Date('2019-01-01'))

    if (isLegacy) {
      window.location.replace(`${WODS_URL}/${formatDate(day, 'yyyy/MM/dd')}`)
    } else {
      history.push(`/${formatDailyDate(day)}`)
    }
  }

  return (
    <Header
      {...header}
      {...headerMenus}
      isLoggedIn={Boolean(userFirstName)}
      welcomeUserText={`${welcomeButtonText} ${userFirstName}`}
      login={<Login />}
      datePicker={
        <DatePicker {...datePicker} handleDayClick={handleDayClick} />
      }
      search={
        shouldShowSearch && GOOGLE_SEARCH_API_KEY ? (
          <SearchBarPopup
            apiKey={GOOGLE_SEARCH_API_KEY}
            type='searchbox-only'
            {...search}
          />
        ) : undefined
      }
    />
  )
}

export default HeaderContainer
